export const { VITE_AUTHORIZATION_TOKEN } = import.meta.env;
